export const WATER_SYSTEM_TYPES = [
  {code: 'COMM', value: 'Community'},
  {code: 'TNC', value: 'Transient Noncommunity'},
  {code: 'NTNC', value: 'Nontransient Noncommunity'}
];